import { CATEGORIES, DELETE_CATEGORY } from "../../graphql/categories";
import { Spin, Table, Tag } from "antd";
import { useMutation, useQuery } from "@apollo/client";

import { Link } from "react-router-dom";
import React from "react";
import moment from "moment";

const Categories = () => {
  const [deleteCategory] = useMutation(DELETE_CATEGORY);
  const { loading, error, data, refetch } = useQuery(CATEGORIES);
  if (error) {
    console.error(error);
  }
  if (loading || !data) {
    return (
      <center>
        <Spin tip="Loading ..." />
      </center>
    );
  }

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => {
        return moment(parseInt(created_at)).format("Do MMMM YYYY");
      },
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (updated_at) => {
        return moment(parseInt(updated_at)).format("Do MMMM YYYY");
      },
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (id) => {
        return (
          <React.Fragment>
            <Link to={`/dashboard/update/category/${id}`}>
              <Tag color="#2176ff">Edit</Tag>
            </Link>
            {/* <Popconfirm
              title="Are you sure to delete this category？"
              onConfirm={() => {
                deleteCategory({ variables: { id } })
                  .then((res) => {
                    message.success(res.data.deleteCategory.message);
                    refetch();
                  })
                  .catch((error) => {
                    let err = JSON.parse(JSON.stringify(error));
                    message.error(err.graphQLErrors[0].message);
                  });
              }}
              okText="Yes"
              cancelText="No"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            >
              <Tag color="#ff4333">Delete</Tag>
            </Popconfirm> */}
          </React.Fragment>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <Table columns={columns} dataSource={data.categories} />
    </React.Fragment>
  );
};

export default Categories;
